import { useCallback, useMemo } from "react";

import { useQuery } from "hooks";
import createResolverFactory from "components/QueryClient/ResolverFactory";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";

export function useUserInvite(advisorId) {
  const queryFactory = useCallback(() => {
    const query = `query advisorSignup ($advisorId: ID!) {
        advisorSignup(advisorId:$advisorId)
      }`;

    const resolver = ({ data: { advisorSignup } }) => {
      return advisorSignup;
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const { data, error, loading, numOfFetches } = useQuery(
    queryFactory,
    useMemo(() => {
      return {
        variables: { advisorId: toGlobalId("Advisor", advisorId) },
        options: { skipAuth: true },
      };
    }, [advisorId])
  );

  const errorMessage = useMemo(() => {
    if (error || error?.length > 0) {
      return (
        error?.[0]?.message ||
        `Apologies, there was an error loading you invite information. 
        Please refresh your browser or contact customer support for help`
      );
    }
    return "";
  }, [error]);

  return {
    loading: loading || numOfFetches === 0,
    email: data,
    errorMessage: errorMessage,
  };
}

export default useUserInvite;
